import * as Utils from 'app/blocks/common/utils';

export const ERROR_INVALID_INVITATION = {
    firstName: { code: 'FIRSTNAME_IS_INVALID', message: 'First name is invalid' },
    lastName: { code: 'LASTNAME_IS_INVALID', message: 'Last name is invalid' },
    email: { code: 'EMAIL_IS_INVALID', message: 'Email has invalid format' },
};

export function validateNameToHaveOnlyLatinCharacters(value, result) {
    return !Utils.validation.validateInputConstrainedLatinExtendedChars(value) && result;
}
export function validateEmail(item, result) {
    return !Utils.validation.isEmailValid(item) && result;
}
export function validateInvitation(invitation) {
    if (!invitation) {
        throw new Error('invitation should be defined');
    }

    const validationResult = {};

    validationResult.firstName = validateNameToHaveOnlyLatinCharacters(
        invitation.firstName,
        ERROR_INVALID_INVITATION.firstName,
    );
    validationResult.lastName = validateNameToHaveOnlyLatinCharacters(
        invitation.lastName,
        ERROR_INVALID_INVITATION.lastName,
    );
    validationResult.email = validateEmail(invitation.email, ERROR_INVALID_INVITATION.email);

    return validationResult;
}

export default async invitation => {
    const validationResult = Utils.validation.asFalseIfAllObjPropsEmpty(validateInvitation(invitation));

    if (validationResult) {
        const error = new Error('Invitation validation error');
        error.result = validationResult;
        return Promise.reject(error);
    }

    return Promise.resolve();
};
